<template>
    <div class="view">
        <h2>Rechercher un utilisateur</h2>
        <b-col cols="5">
            <b-form @submit="onSubmit" @reset="onReset" v-if="show">
                <b-row>
                    <b-col>
                        <b-form-group id="input-group-1" label="Identifiant" label-for="input-1">
                            <b-form-input
                                    id="input-1"
                                    v-model="utilisateur.username"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group id="input-group-2" label="E-mail" label-for="input-2">
                            <b-form-input
                                    id="input-2"
                                    v-model="utilisateur.email"
                                    type="text"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group id="input-group-nom" label="Nom" label-for="input-nom">
                            <b-form-input
                                    id="input-nom"
                                    v-model="utilisateur.nom"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group id="input-group-prenom" label="Prénom" label-for="input-prenom">
                            <b-form-input
                                    id="input-prenom"
                                    v-model="utilisateur.prenom"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group id="input-group-3" label="Rôle" label-for="input-3">
                            <b-form-select
                                    id="input-3"
                                    v-model="utilisateur.roles"
                                    :options="roles">
                                <template v-slot:first>
                                    <b-form-select-option :value="null">
                                        Sélectionner un rôle
                                    </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group id="input-group-marche" label-for="input-marche" label="Marché">
                            <AutocompleteCustom
                                    id="input-marche"
                                    :items="marcheIdsItems"
                                    v-model="utilisateur.marche"
                                    @search="onMarcheSearch"
                                    :placeholder=libelles.selectionnerMarche>
                            </AutocompleteCustom>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-button type="submit" variant="primary" class="boutonSelect">Soumettre</b-button>
                <b-button type="reset" variant="danger" class="boutonSelect">Réinitialiser</b-button>
                <b-button type="button" variant="success" class="boutonSelect" @click="exporter">Exporter</b-button>
            </b-form>
        </b-col>
        <div v-if="formSubmitted" class="pt-5">

            <div class="overflow-auto">
                <b-row class="align-content-center">
                    <b-col cols="2">
                        <b-form-select
                                v-model="pageSize"
                                :options="pageSizes"
                                @change="search()"
                        ></b-form-select>
                    </b-col>
                    <b-col cols="4" offset="1">
                        <b-pagination
                                v-model="pageIndex"
                                :total-rows="utilisateursResult.totalElements"
                                :per-page="pageSize"
                                :limit="10"
                                align="center"
                                @input="search()"
                        ></b-pagination>
                    </b-col>
                    <b-col>
                        <b-button v-if="checkedUsers.length > 0"
                                  type="button" variant="danger" disabled
                                  v-b-modal="'modal-deleteUsers'">
                            Supprimer les utilisateurs
                        </b-button>
                        <b-modal
                                :id="'modal-deleteUsers'"
                                title="Supprimer des utilisateurs"
                                ok-title="Confirmer"
                                cancel-title="Annuler"
                                @ok="deleteUsers">
                            <div v-html="modalDeleteUsersText"></div>
                        </b-modal>
                    </b-col>
                </b-row>

                <b-table striped hover
                         :per-page="pageSize"
                         :no-local-sorting="true"
                         @sort-changed="sort"
                         :items="utilisateursTable" :fields="fields">
                    <template v-slot:cell(num)="row">
                        <div>
                            <b-form-checkbox
                                    :id="'checkbox_' + (pageSize * (pageIndex - 1) + (row.index + 1))"
                                    @input="checkUser($event, row.item)"
                                    :checked="isChecked(row.item.id)">
                                {{pageSize * (pageIndex - 1) + (row.index + 1)}}
                            </b-form-checkbox>
                        </div>
                    </template>
                    <template v-slot:cell(email)="row">
                        <div v-b-tooltip.hover
                             :title="row.value">
                            {{truncate(row.value)}}
                        </div>
                    </template>
                    <template v-slot:cell(roles)="row">
                        <div v-b-tooltip.hover
                             :title="row.value">
                            {{truncate(row.value)}}
                        </div>
                    </template>
                    <template v-slot:cell(edit)="row">
                        <b-button size="sm" @click="editUtilisateur(row.item.id)"
                                  :disabled="isDisabled(row.item.roles)">
                            <Icon icon="edit" size="1x"></Icon>
                        </b-button>
                    </template>
                    <template v-slot:cell(delete)="row">
                        <b-button size="sm" v-b-modal="'modal-delete' + row.item.id"
                                  :disabled="isDisabled(row.item.roles)">
                            <Icon icon="trash" size="1x"></Icon>
                        </b-button>
                        <b-modal
                                :id="'modal-delete' + row.item.id"
                                title="Suppression d'utilisateur"
                                ok-title="Confirmer"
                                cancel-title="Annuler"
                                @ok="deleteUtilisateur(row.item.id)">
                            <p>Confirmez-vous la suppression de cet utilisateur ?</p>
                        </b-modal>
                    </template>
                </b-table>
            </div>
        </div>
        <br/>
    </div>

</template>

<script>
  import UtilisateurStore from '@/stores/UtilisateurStore'
  import AlertStore from '@/stores/AlertStore'
  import UtilisateurDto from "../../dtos/UtilisateurDto";
  import {RoleEnum} from "../../constants/enums";
  import {libelles} from '../../constants/libelles';
  import AutocompleteCustom from "../../components/AutocompleteCustom";
  import MarcheStore from "../../stores/MarcheStore";
  import {
    ROLES_ADMIN,
    ROLES_GPEC,
    ROLES_SECURITE,
    ROLES_EMPREINTE,
    ROLES_EFFECTIFS
  } from "../../constants/common";
  import hasPermission from "../../filters/hasPermission";
  import {truncate} from "../../utils/stringUtil";
  import FileUtil from "@/utils/fileUtil";

  export default {
    components: {AutocompleteCustom},
    data() {
      return {
        formSubmitted: false,
        show: true,
        utilisateur: new UtilisateurDto(),
        utilisateursResult: null,
        pageSize: null,
        pageSizes: [10, 25, 50, 100],
        pageIndex: null,
        sortOptions: null,
        roles: Object.entries(RoleEnum).map(value => {
          return {text: value[1], value: [value[0]]}
        }),
        fields: [
          {label: '', key: 'num', sortable: false},
          {label: 'Identifiant', key: 'username', sortable: true},
          {label: 'Nom', key: 'nom', sortable: true},
          {label: 'Prénom', key: 'prenom', sortable: true},
          {label: 'Email', key: 'email', sortable: true},
          {label: 'Rôle(s)', key: 'roles', sortable: true},
          {label: 'Dernière connexion', key: 'lastLogin', sortable: true},
          {label: 'Consulter / Modifier', key: 'edit', sortable: false},
          {label: 'Supprimer', key: 'delete', sortable: false}
        ],
        libelles: libelles,
        marches: [],
        marcheIdsItems: [],
        checkedUsers: []
      }
    },
    computed: {
      utilisateursTable: function () {
        return this.utilisateursResult.content.map(utilisateur => {
          return {
            id: utilisateur.id,
            username: utilisateur.username,
            nom: utilisateur.nom,
            prenom: utilisateur.prenom,
            email: utilisateur.email,
            roles: utilisateur.roles.map(role => role.role).join(", "),
            lastLogin: new Date(utilisateur.lastLogin).toLocaleDateString(),
          }
        });
      },
      modalDeleteUsersText() {
        let li = '';
        for (const user of this.checkedUsers) {
          li += `<li>${user.prenom} ${user.nom}</li>`;
        }
        return `<p>Attention, vous allez supprimer les utilisateurs suivants :</p><ul>${li}</ul><p>Voulez-vous continuer ?</p>`;
      }
    },
    mounted() {
      this.initPagination();
      MarcheStore.getAll().then(marches => {
        this.marches = marches.map(marche => {
          return {text: `${marche.reference} (${marche.libelleCourt})`, value: marche.id};
        });
        this.marcheIdsItems = this.marches;
      });
    },
    methods: {
      truncate(value) {
        return truncate(value, 30);
      },
      initPagination() {
        this.pageSize = 10;
        this.pageIndex = 1;
        this.sortOptions = [{sortBy: 'username', sortDirection: 'asc'}];
      },
      search() {
        UtilisateurStore.search(this.utilisateur, this.pageIndex - 1, this.pageSize, this.sortOptions).then(
            result => {
              this.utilisateursResult = result.data;
              this.formSubmitted = true;
            },
            error => AlertStore.pushError(error.response.data.message)
        )
      },
      editUtilisateur(id) {
        this.$router.push("/utilisateurs/" + id);
      },
      deleteUtilisateur(id) {
        UtilisateurStore.delete(id).then(() => {
          this.search();
        });
      },
      sort(sort) {
        this.sortOptions = [{sortBy: sort.sortBy, sortDirection: sort.sortDesc ? 'desc' : 'asc'}];
        this.search();
      },
      onSubmit(evt) {
        evt.preventDefault();
        this.initPagination();
        this.checkedUsers = [];
        this.search();
      },
      onReset(evt) {
        evt.preventDefault();
        this.utilisateur = new UtilisateurDto();
        this.formSubmitted = false;
        this.show = false;
        this.$nextTick(() => {
          this.show = true
        })
      },
      isDisabled(roles) {
        if (hasPermission(["ADMINISTRATEUR"])) {
          return false;
        }
        if (roles.split(', ').some(role => ROLES_ADMIN.includes(role))) {
          return true;
        }
        return !(
            hasPermission(["CORRESPONDANT_EMPREINTE_ADMINISTRATEUR"]) && roles.split(', ').some(v => ROLES_EMPREINTE.includes(v)) ||
            hasPermission(["CORRESPONDANT_EFFECTIFS_ADMINISTRATEUR"]) && roles.split(', ').some(v => ROLES_EFFECTIFS.includes(v)) ||
            hasPermission(["CORRESPONDANT_SECURITE_ADMINISTRATEUR"]) && roles.split(', ').some(v => ROLES_SECURITE.includes(v)) ||
            hasPermission(["CORRESPONDANT_GPEC_ADMINISTRATEUR"]) && roles.split(', ').some(v => ROLES_GPEC.includes(v))
        );
      },
      onMarcheSearch(marche, isId) {
        this.marcheIdsItems = MarcheStore.onMarcheSearch(marche, isId, this.marches)
      },
      isChecked(userId) {
        return this.checkedUsers.some(user => user.id === userId);
      },
      checkUser(event, user) {
        if (event) {
          this.checkedUsers.push(user);
        } else {
          this.checkedUsers = this.checkedUsers.filter(value => value.id !== user.id);
        }
      },
      deleteUsers() {
        const userIds = this.checkedUsers.map(value => value.id);
        UtilisateurStore.deleteAll(userIds).then(() => {
          this.checkedUsers = [];
          this.search();
        });
      },
      exporter() {
        UtilisateurStore.export().then(
            result => {
              FileUtil.downloadFile(result.data, 'text/csv;charset=utf8;');
            },
            error => AlertStore.pushError(error.response.data.message)
        )
      }
    }
  }
</script>
<style scoped>
.boutonSelect {
  margin-right: 0.5%;
}
</style>
